<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">High Profile Cases</h2>
    <div v-if="cases.length <= 0" class="text-center pt-16">
      <p class="text-3xl">Loading...</p>
    </div>
    <div v-if="cases.length > 0" class="grid grid-cols-12 gap-6 mt-5">
      <!-- BEGIN: High Profile Cases -->
      <div
        v-for="(caseFile, key) in cases"
        :key="key"
        class="intro-y col-span-12 md:col-span-6 lg:col-span-4"
      >
        <div class="box">
          <div class="flex items-start px-5 pt-5">
            <div class="w-full flex flex-col lg:flex-row items-center">
              <div class="text-center lg:text-left mt-3 lg:mt-0">
                <a
                  :href="host_url + '/cases/' + caseFile.slug"
                  class="font-medium"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {{ caseFile.name }}
                </a>
                <div class="text-gray-600 text-xs mt-2">
                  {{ caseFile.defendants[0].name }}
                </div>
                <div class="text-gray-600 text-xs">
                  {{ caseFile.defendants[0].designation }}
                </div>
              </div>
            </div>
          </div>
          <div class="text-center lg:text-left p-5 py-3">
            <!-- <div>{{ caseFile.charge }}</div> -->
            <div
              class="flex items-center justify-center lg:justify-start text-gray-600"
            >
              Date of Arraignment: {{ caseFile.date_of_arraignment }}
            </div>
            <div
              class="flex items-center justify-center lg:justify-start text-gray-600"
            >
              Duration: {{ caseFile.duration.duration_in_days }}
            </div>
            <div
              class="flex items-center justify-center lg:justify-start text-gray-600"
            >
              Status: {{ caseFile.case_status }}
            </div>
          </div>
        </div>
      </div>
      <!-- END: High Profile Cases -->
      <!-- BEGIN: Pagination -->
      <div
        class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center"
      >
        <ul class="pagination">
          <li>
            <button class="pagination__link" @click="gotoPage(1)">
              <ChevronsLeftIcon class="w-4 h-4" />
            </button>
          </li>
          <li>
            <button class="pagination__link" @click="prevPage">
              <ChevronLeftIcon class="w-4 h-4" />
            </button>
          </li>
          <li>
            <button class="pagination__link" @click="nextPage">
              <ChevronRightIcon class="w-4 h-4" />
            </button>
          </li>
          <li>
            <button class="pagination__link" @click="gotoPage(totalPages)">
              <ChevronsRightIcon class="w-4 h-4" />
            </button>
          </li>
        </ul>
      </div>
      <!-- END: Pagination -->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "NeverEndingCases",
  data() {
    return {
      cases: [],
      host_url: process.env.VUE_APP_CCD_CLIENT_URL,
      current_page: 1,
      page_size: 50,
      sortedList: [],
      message: "Loading...",
      total: 0,
      totalPages: 0,
      from: 0,
      to: 0
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.getCases();
      }
    }
  },
  mounted() {
    this.getCases();
  },
  methods: {
    loadMore() {
      this.page++;
      this.getCases();
    },
    getCases() {
      axios
        .get(`${window.host}/api/profile-cases`, {
          params: { ...this.filterParams, page: this.current_page }
        })
        .then(response => {
          if (response.data) {
            this.total = response.data.total;
            this.totalPages = response.data.last_page;
            this.from = response.data.from;
            this.to = response.data.to;
            this.cases = response.data.data;
          }
        });
    },
    gotoPage(index) {
      if (this.current_page == index) return;

      this.current_page = index;
      this.getCases();
    },
    nextPage() {
      if (this.current_page < this.totalPages) {
        this.current_page++;
        this.getCases();
      }
    },
    prevPage() {
      if (this.current_page > 1) {
        this.current_page--;
        this.getCases();
      }
    }
  }
};
</script>
